import { LeadWillingness } from '../domain/types';
import { leadWillingnessLabels } from '../labels/leadWillingnessLabels';

export const leadWillingnessSelectOptions = Object.keys(leadWillingnessLabels).map((value) => ({
  value,
  label: leadWillingnessLabels[value as LeadWillingness],
}));
